import { createAsyncThunk } from '@reduxjs/toolkit';

import { selectBusinessDetails } from '../../selectors/selectBusinessDetails';
import { refDataApi } from '../../services/refData';
import { RootState } from '../../store';
import { utcDateFormatter } from '../../utils';
import { updateOccupationsList } from './index';

export const getOccupationListAction = createAsyncThunk<
  void,
  void,
  {
    state: RootState;
  }
>('businessDetails/getOccupationList', async (_, { dispatch, getState }) => {
  const businessDetails = selectBusinessDetails(getState());
  if (businessDetails.coverStart) {
    const response = await dispatch(
      refDataApi.endpoints?.getOccupationsList.initiate({
        effectiveDate: businessDetails.coverStart
          ? utcDateFormatter(businessDetails.coverStart)
          : '',
      })
    ).unwrap();
    dispatch(updateOccupationsList(response?.occupations));
  }
});
